import { get, put, destroy } from '.';

export function UpdateAccountUser(id, options = {}) {
	return put<any>("/app/api/account_users/" + (id || 0).toString(), options);
}

export function GetAccountUsers(options = {}) {
	return get<any>("/app/api/account_users", options)
}

export function DestroyAccountUser(id: string, options = {}) {
	return destroy<any>(`/app/api/account_users/${id}`, options)
}

export function ActivateAccountUser(id: string, options = {}) {
	return put<any>(`/app/api/account_users/${id}/activate`, options)
}

export function GetCsRepUsers(options = {}) {
	return get<any>("/app/api/account_users/cs_reps", options)
}
